
"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { type ThemeProviderProps } from "next-themes/dist/types"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const [mounted, setMounted] = React.useState(false)

  // Only show the theme content when mounted to avoid hydration mismatch
  React.useEffect(() => {
    setMounted(true)
    // Set theme to light on mount
    document.documentElement.classList.remove('dark')
    document.documentElement.classList.add('light')
    console.log("Theme provider mounted, using light theme");
  }, [])

  return (
    <NextThemesProvider {...props} forcedTheme="light" disableTransitionOnChange>
      {mounted ? (
        <div className="min-h-screen transition-colors duration-300">
          {children}
        </div>
      ) : (
        <div className="min-h-screen">{children}</div>
      )}
    </NextThemesProvider>
  )
}
